import {
  ADMIN_TENANTS_FETCH_REQUEST,
  ADMIN_TENANTS_FETCH_SUCCESS,
  ADMIN_TENANTS_FETCH_FAILURE,
  ADMIN_TENANTS_TEST_TENANT_SAVED
} from '../actions/adminTenantsActions';

const initialState = {
  status: 'idle',
  error: null,
  counts: null,
  lastLoadedAt: null,
  requestId: 0,
  testTenantOverrides: {}
};

const adminTenantsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADMIN_TENANTS_FETCH_REQUEST:
      return {
        ...state,
        status: 'pending',
        error: null,
        requestId: action.requestId
      };

    case ADMIN_TENANTS_FETCH_SUCCESS:
      return {
        ...state,
        status: 'succeeded',
        error: null,
        counts: action.counts,
        lastLoadedAt: action.lastLoadedAt,
        testTenantOverrides: Object.fromEntries(
          Object.entries(state.testTenantOverrides).filter(
            ([, override]) => override.afterRequestId >= action.requestId
          )
        )
      };

    case ADMIN_TENANTS_TEST_TENANT_SAVED:
      return {
        ...state,
        testTenantOverrides: {
          ...state.testTenantOverrides,
          [action.tenantId]: {
            value: action.value,
            afterRequestId: state.requestId
          }
        }
      };

    case ADMIN_TENANTS_FETCH_FAILURE:
      return {...state, status: 'failed', error: action.error};

    default:
      return state;
  }
};

export default adminTenantsReducer;
